<template>
  <el-select
    ref="contract"
    v-model="selected"
    placeholder="Selecione  uma opção"
    @change="update()"
  >
    <el-option
      v-for="row of records"
      :key="row.id"
      :label="`${row.contractid} - ${row.name}`"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { ContractService } from "@/services/customers/contract.services";
export default {
  name: "ContractList",
  props: ["current"],
  data: function () {
    return {
      records: [],
      selected: "",
    };
  },
  methods: {
    fetchRecords() {
      const vm = this;
      ContractService.list()
        .then((response) => {
          vm.records = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
};
</script>